import { Form, Select } from "antd";
import { useMemo } from "react";
import * as countryCodes from "country-codes-list";
import { getCountryCode } from "../../user-information/utils";

const { Option } = Select;

interface PrefixSelectorProps {
  name?: string;
  dependency?: string;
}

export const PrefixSelector: React.FC<PrefixSelectorProps> = ({
  name = 'countryCode',
  dependency = 'phoneNumber'
}) => {
  const countryCodesObject = useMemo(
    () =>
      countryCodes.customList(
        "countryCode",
        "{countryNameEn}:{countryCallingCode}",
      ),
    [],
  );
  const countryCode = getCountryCode(countryCodesObject);

  return (
    <Form.Item
      name={name}
      noStyle
      dependencies={[dependency]}
    >
      <Select
        style={{ width: 90, borderRadius: 0 }}
        placeholder="Code"
        getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
      >
        <Option key="select" value="">
          Select
        </Option>
        {countryCode.map(({ code }) => (
          <Option key={code} value={code}>
            +{code}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};
